import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-item-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/danielbrenesgomez/" target="_blank">
                <img src={navIcon1} alt="linkedin" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100086437136007" target="_blank">
                <img src={navIcon2} alt="facebook" />
              </a>
              <a href="https://www.instagram.com/buyoi_software/" target="_blank">
                <img src={navIcon3} alt="intagram" />
              </a>
            </div>
            <p>buyoi@interfractal.com</p>
          </Col>
          <p>CopyRight 2023. All rights Reserved. Buyoi</p>
        </Row>
      </Container>
    </footer>
  );
};
